// extracted by mini-css-extract-plugin
export default {"admin_wapper":"AdminDashboard_admin_wapper__tdApK","admin_dashboard_container":"AdminDashboard_admin_dashboard_container__JAfyK"};